module.exports = __webpack_public_path__ + "media/bootstrap-icons/easel-fill-0de0063a.svg";